import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "bd0c41c0-732b-4c66-9fb5-6d77c34d7a68", content: "It is heard as a distinct echo.", options: {} },
  { id: "28359188-452e-4a2c-bf34-bb35097d3a64", content: "It has no audible effect.", options: {} },
  { id: "cc4e1990-3bac-4d9f-bdb7-d6007a66ba43", content: "It creates undesirable<br>tone colouration.", options: {} },
  {
    id: "80f5f0c4-f9b3-4ff5-aaa8-48be43b2527d",
    content: "It increases the apparent<br>loudness of the source.",
    options: {},
  },
];

export const task: Task = {
  id: "f851e2b1-5196-4c99-8326-707f2116677d",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: false,
    columns: 1,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["bd0c41c0-732b-4c66-9fb5-6d77c34d7a68"],
};
